/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

//fullscreen
import VueFullscreen from 'vue-fullscreen'
Vue.use(VueFullscreen)


//vmask
import VueMask from 'v-mask'
Vue.use(VueMask)


// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

//Session
import VueSession from 'vue-session'
Vue.use(VueSession)

//i18n
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// i18n
import i18n from './i18n/i18n'

//days
import * as dayjs from 'dayjs'
import * as relativeTimePlugin from 'dayjs/plugin/relativeTime'
require('dayjs/locale/es')
require('dayjs/locale/en')
dayjs.locale(i18n.locale)
dayjs.extend(relativeTimePlugin)
Vue.prototype.$dayjs = dayjs 

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

//Digital font
require('./assets/css/digitalfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// Config Cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('1d', null, null, null, true, 'Strict')

import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import { getToken } from '@/sessionStorage'

Vue.use(new VueSocketIO({
  debug: false,
  connection: SocketIO.connect(process.env.VUE_APP_SOCKET_URL || '', {
    extraHeaders: {
      token: getToken()
    },
    autoConnect: true
  }),
  vuex: {
    store
  }
})
)

Vue.config.productionTip = false

export const messages = async () => {
  
  const es = await axios({ url: `${process.env.VUE_APP_LANG_URL}/es.json`, method: 'GET' }).then(res => res.data).catch(err => console.log(err))
  const en = await axios({ url: `${process.env.VUE_APP_LANG_URL}/en.json`, method: 'GET' }).then(res => res.data).catch(err => console.log(err))

  i18n.setLocaleMessage('en', en)
  i18n.setLocaleMessage('es', es)
  return {
    en,
    es
  }
}

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
